import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateRepeat } from "../../services/repeat";
import { IIndicators } from "../../types/indicator";
import { toast } from "react-toastify";

const useUpdateRepeat = (indicator: IIndicators) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateRepeat,
    onMutate: () => {
      indicator.setIsProcessRunning(true);
      indicator.setIsServiceError(null);
    },

    onSuccess: (status) => {
      if (status === 200) {
        queryClient.invalidateQueries({ queryKey: ["repeats"] });
        indicator.setIsProcessRunning(false);
        indicator.setIsServiceError(null);
        toast.success("Repeat updated successfully");
      }
    },

    onError: (error: any) => {
      indicator.setIsServiceError(error?.response?.data?.message);
      indicator.setIsProcessRunning(false);
      toast.error(error?.response?.data?.message);
    },
  });
};

export default useUpdateRepeat;
